<script setup lang="ts">
import ShipReserveModal from '../ShipReserveModal.vue';
import { SearchMode } from '@utils/types';
import SearchReserveForm from '@components/util/search/SearchReserveForm.vue';
import { ReserveType } from '@utils/itinerary';
import { type Radio } from '@components/base/mr-radio-button';

const { isChangeSearch, loading } = defineProps<{
    isChangeSearch?: boolean;
    loading?: boolean;
}>();
const shipForm = useShipForm();
const { open } = usePopOver({
    component: ShipReserveModal,
});
const i18n = useI18n();
const route = useRoute();

const form = useTripSearchForm(isChangeSearch);

const destinationListMessage = computed(() =>
    !form.origin.value ? 'ابتدا پایانه مبدا را انتخاب کنید.' : undefined
);
const shipOptions: Radio<SearchMode>[] = [
    {
        label: i18n.t('Search.foreign'),
        value: SearchMode.Foreign,
    },
];
const onReserve = async () => {
    try {
        await shipForm.verifySearchForm(route.fullPath);
        await shipForm.getSearchUrl();
        await shipForm.loadShippingPrice({
            originCode: form.origin.value!.code,
            destinationCode: form.destination.value!.code,
        });
        const result = await open();
        if (result.args?.[0]) {
            onSuccess();
        }
    } catch (error) {
        if (typeof error === 'string') {
            swal({
                title: i18n.t('Search.attention'),
                text: error as string,
                icon: 'warning',
                confirmButtonText: i18n.t('Search.ok'),
            });
        } else {
            handleException(error);
        }
    }
};
const onSuccess = () => {
    swal({
        title: 'درخواست رزرو کشتی ثبت شد!',
        text: 'همکاران ما جهت هماهنگی‌های رزرو و پرداخت، با شما تماس خواهند گرفت.',
        icon: 'success',
        confirmButtonText: i18n.t('Search.ok'),
        timer: 5000,
    });
};
</script>

<template>
    <SearchReserveForm
        v-bind="form"
        :is-change-search
        :loading
        :search-mode-options="shipOptions"
        :reserve-type="ReserveType.Ship"
        :origin-title="i18n.t('SearchShipForm.originTerminal')"
        :destination-title="i18n.t('SearchShipForm.destinationTerminal')"
        :empty-destination-message="destinationListMessage"
    >
        <template #submit-button>
            <mr-button size="big" full-width @click="onReserve">
                درخواست رزرو
            </mr-button>
        </template>
    </SearchReserveForm>
</template>
